// import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Aos from 'aos';

import { Helmet } from "react-helmet";
import Home from './Pages/Home/Home';
import Blog from './Pages/Blog/Blog';
import Contact from './Pages/Contact/Contact';



import Collegemainpage from './Pages/Collegemianpage/Collegemainpage';
import Aboutus from './Pages/Aboutus/Aboutus';
import Coursemainpage from './Pages/Collegemianpage/Coursemainpage';
import Branches from './Pages/Collegemianpage/Branches';
import Term from './Pages/Termcondition/Term';
import Toptoscroll from './Components/Toptoscroll/Toptoscroll';
import Weblayout from './Components/Weblayout';
import UserLogin from './Pages/Auth/UserLogin'; // Import UserLogin
import Admin_Layout from './Admin/Admin_Layout';
import AdminLogin from './Admin/AdminLogin';
import StreamList from './Admin/StreamList';
import AddStreamForm from './Admin/AddStreamForm';
import CollegePage from './Admin/CollegePage';
import AddCollegePage from './Admin/AddCollegePage';
import NavCoursePageList from './Admin/NavCoursePageList';
import AddNavCoursePage from './Admin/AddNavCoursePageList';

import Reviewcomp from './Components/Reviewcomp/Reviewcomp';
import Topuniversities from './Components/Header/Explorepages/Topuniversities';
import Admissionalert from './Components/Header/Explorepages/Admissionalert';
import Ecplorecourse from './Components/Header/Explorepages/Ecplorecourse';
import Studyabroad from './Components/Header/Explorepages/Studyabroad';
import Institutes from './Components/Header/Explorepages/Institutes';
import Scholarship from './Components/Header/Explorepages/Scholarship';
import Engineering from './Components/Cardslider/Innerpages/Engineering';
import Ranking from './Components/Explore/Innerpages/Ranking';
import Exam from './Components/Explore/Innerpages/Exam';
import Collegepre from './Components/Explore/Innerpages/Collegepre';
import Innerpage from './Components/Collegranking/Innerpage';
import Courseprogram from './Components/Program/Innerpageprog/Courseprogram';
import Innerpagetopstudy from './Components/TopstudyPlaces/Innerpages/Innerpagetopstudy';
import CompareColleges from './Components/CompareColleges';
import Privacypolicy from './Pages/Privacypolicy/Privacypolicy';
import Notfoundpage from './Pages/Notfound/Notfoundpage';
import CardSlider from './Admin/CardSlider';
import AddCardSlider from './Admin/AddCardSlider';
import LeadsList from './Admin/LeadsList';
import Program from './Admin/Program';
import AddProgram from './Admin/AddProgram';
import InnerColleges from './Components/Colleges/InnerColleges';
import StudyGoalColleges from './Components/Colleges/StudyGoalColleges';
import Page from './Pages/Studyabroad/Page';
import Studyabroadpage from './Admin/Studyabroadpage';
import AddStudyabroadpage from './Admin/AddStudyabroadpage';
import EditStudyAbroad from './Admin/EditStudyAbroad';
import EditProgram from './Admin/EditProgram';
import EditStreamForm from './Admin/EditStreamForm';
import EditCollegePage from './Admin/EditCollegePage';
import EditCardSlider from './Admin/EditCardSlider';
import EditNavCoursePage from './Admin/EditNavCoursePage';
import SubscribeList from './Admin/SubscribeList';
import AdminDashboard from './Admin/AdminDashboard';
import ReviewList from './Admin/ReviewList';
import ProtectedRoute from './Admin/ProtectedRoute';
import Forgetpassword from './Admin/Forgetpassword';
import Streamdetailpage from './Pages/Collegemianpage/Streamdetailpage';
import BulkCollegeJsonUpload from './Admin/BulkCollegeJsonUpload';

// import Loader from './Components/Loader/Loader';


function App() {

  // scroll to top on page load
  // scroll button .......------------------------------
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 2000) { // Adjust the scroll position as needed
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };




  useEffect(() => {
    Aos.init();
  }, [])


  return (
    <>
      <div>
        {/* only for favicon show all pages  */}
        <Helmet>
          <title>GetFast Education | Top Best Consultancy for Admissions & Colleges</title>
          <meta name="description" content="GetFast Education provides expert guidance for admissions in online, regular, and distance colleges. All educational services provided by GetFast Education." />
          <link rel="icon" type="image/png" href="/favi.png" />
        </Helmet>


        {/* Router  */}
        <BrowserRouter >
          <Toptoscroll />
          <Routes>
            {/* Navbar All  Pages   */}

            {/* only page not fonnd  */}
            <Route path='*' element={
              <Notfoundpage />
            }></Route>
            <Route path='/' element={
              <Weblayout>
                <Home />
              </Weblayout>
            }></Route>

            {/* User Login Route */}
            <Route path='/login' element={
              <UserLogin />
            }></Route>

            <Route path='/About' element={
              <Weblayout>
                <Aboutus />
              </Weblayout>
            }></Route>
            <Route path='/Blog' element={
              <Weblayout>
                <Blog />
              </Weblayout>
            }></Route>
            <Route path='/contact' element={
              <Weblayout>
                <Contact />
              </Weblayout>
            }></Route>
            <Route path='/terms&condition' element={
              <Weblayout>
                <Term />
              </Weblayout>
            }></Route>

            <Route path='/Privacy-Policy' element={
              <Weblayout>
                <Privacypolicy />
              </Weblayout>
            }></Route>


            <Route path='/review' element={
              <Weblayout>
                <Reviewcomp />
              </Weblayout>
            }></Route>


            <Route path='/Institutes' element={
              <Weblayout>
                <Institutes />
              </Weblayout>
            }></Route>


            <Route path='/Scholarship' element={
              <Weblayout>
                <Scholarship />
              </Weblayout>
            }></Route>



            {/* Nav Explore  section pages here */}

            <Route path='/TopUniversitiesandColleges' element={
              <Weblayout>
                <Topuniversities />
              </Weblayout>
            }></Route>

            {/* Stream-Specific Pages */}
            <Route path='/TopUniversitiesandCollegesTag_Engineering' element={
              <Weblayout>
                <Topuniversities />
              </Weblayout>
            }></Route>

            <Route path='/TopUniversitiesandCollegesTag_Medical' element={
              <Weblayout>
                <Topuniversities />
              </Weblayout>
            }></Route>

            <Route path='/TopUniversitiesandCollegesTag_MBA' element={
              <Weblayout>
                <Topuniversities />
              </Weblayout>
            }></Route>

            <Route path='/TopUniversitiesandCollegesTag_Study Abroad' element={
              <Weblayout>
                <Topuniversities />
              </Weblayout>
            }></Route>

            <Route path='/Admissionalert' element={
              <Weblayout>
                <Admissionalert />
              </Weblayout>
            }></Route>


            <Route path='/TopCourse' element={
              <Weblayout>
                <Ecplorecourse />
              </Weblayout>
            }></Route>

            <Route path='/StudyAbroad' element={
              <Weblayout>
                <Studyabroad />
              </Weblayout>
            }></Route>






            {/* Select Your Study Goal Card slider pages link here  */}

            <Route path='/c_pages/:courseName' element={
              <Weblayout>
                <Engineering />
              </Weblayout>
            }></Route>



            {/* Explore Programs  Component here  */}

            <Route path='/CollegRanking' element={
              <Weblayout>
                <Ranking />
              </Weblayout>
            }></Route>


            <Route path='/Exam' element={
              <Weblayout>
                <Exam />
              </Weblayout>
            }></Route>

            <Route path='/college-predictor' element={
              <Weblayout>
                <Collegepre />
              </Weblayout>
            }></Route>

            <Route path='/programs' element={
              <Weblayout>
                <Ecplorecourse />
              </Weblayout>
            }></Route>

            <Route path='/compare' element={
              <Weblayout>
                <CompareColleges />
              </Weblayout>
            }></Route>

            <Route path='/College-Ranking' element={
              <Weblayout>
                <Innerpage />
              </Weblayout>
            }></Route>



            {/* Find Your Perfect University Match Online */}
            {/* our programe section */}
            <Route path='/Programe-course/:id' element={
              <Weblayout>
                <Courseprogram />
              </Weblayout>
            }></Route>

            <Route path='/TopStudy-colleges' element={
              <Weblayout>
                <InnerColleges />
              </Weblayout>
            }></Route>

            <Route path='/goalStudy-colleges' element={
              <Weblayout>
                <StudyGoalColleges />
              </Weblayout>
            }></Route>

            <Route path='/TopStudy-colleges/:state' element={
              <Weblayout>
                <Innerpagetopstudy />
              </Weblayout>
            }></Route>


            {/* study abroad pages link here  */}


            <Route path='/Study-abroad/:id' element={
              <Weblayout>
                <Page />
              </Weblayout>
            }></Route>


            {/* main course page route here  */}

            <Route path='/Collegespage/:id' element={
              <Weblayout>
                <Collegemainpage />
              </Weblayout>
            }></Route>
            <Route path="/college/:id" element={
              <Weblayout>
                <Coursemainpage />
              </Weblayout>
            } />

            <Route path="/branch/:collegeid/:courseid" element={
              <Weblayout>
                <Branches />
              </Weblayout>
            } />


            <Route path="/streamdetailpage/:id" element={
              <Weblayout>
                <Streamdetailpage />
              </Weblayout>
            } />

            <Route path="/admin" element={
              <>
                <AdminLogin />
              </>
            } />
            <Route path="/admin/bulk" element={
              <>
                <BulkCollegeJsonUpload />
              </>
            } />

            <Route path="/admin/forget_pass" element={
              <>
                <Forgetpassword />
              </>
            } />

            <Route path="/admin/dashboard" element={
              <ProtectedRoute><Admin_Layout>
                <AdminDashboard />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/cardslider" element={
              <ProtectedRoute><Admin_Layout>
                <CardSlider />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/add_cardslider" element={
              <ProtectedRoute><Admin_Layout>
                <AddCardSlider />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/edit_cardslider/:id" element={
              <ProtectedRoute><Admin_Layout>
                <EditCardSlider />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/collegepage" element={
              <ProtectedRoute><Admin_Layout>
                <CollegePage />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/navcoursepagelist" element={
              <ProtectedRoute><Admin_Layout>
                <NavCoursePageList />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/add_navcoursepagelist" element={
              <ProtectedRoute><Admin_Layout>
                <AddNavCoursePage />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/edit_navcoursepagelist/:id" element={
              <ProtectedRoute><Admin_Layout>
                <EditNavCoursePage />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/add_collegepage" element={
              <ProtectedRoute><Admin_Layout>
                <AddCollegePage />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/edit_collegepage/:id" element={
              <ProtectedRoute><Admin_Layout>
                <EditCollegePage />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/stream" element={
              <ProtectedRoute><Admin_Layout>
                <StreamList />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/program" element={
              <ProtectedRoute><Admin_Layout>
                <Program />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="admin/add_program" element={
              <ProtectedRoute><Admin_Layout>
                <AddProgram />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/edit_program/:id" element={
              <ProtectedRoute><Admin_Layout>
                <EditProgram />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/leads" element={
              <ProtectedRoute><Admin_Layout>
                <LeadsList />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/review" element={
              <ProtectedRoute><Admin_Layout>
                <ReviewList />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/subscribe" element={
              <ProtectedRoute><Admin_Layout>
                <SubscribeList />
              </Admin_Layout></ProtectedRoute>
            } />
            <Route path="/admin/StudyAbroad" element={
              <ProtectedRoute><Admin_Layout>
                <Studyabroadpage />
              </Admin_Layout></ProtectedRoute>
            } />
            <Route path="/admin/AddStudyAboradpage" element={
              <ProtectedRoute><Admin_Layout>
                <AddStudyabroadpage />
              </Admin_Layout></ProtectedRoute>
            } />
            <Route path="/admin/EditStudyAbroad/:id" element={
              <ProtectedRoute><Admin_Layout>
                <EditStudyAbroad />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/add_stream" element={
              <ProtectedRoute><Admin_Layout>
                <AddStreamForm />
              </Admin_Layout></ProtectedRoute>
            } />

            <Route path="/admin/edit_stream/:id" element={
              <ProtectedRoute><Admin_Layout>
                <EditStreamForm />
              </Admin_Layout></ProtectedRoute>
            } />

          </Routes>
        </BrowserRouter>



        {/* css for scroll top  */}
        <i className="fa fa-arrow-up fs-1 scroll-to-top"
          onClick={scrollToTop}
          style={{
            display: visible ? 'block' : 'none',
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            color: '#ff7900',
            padding: '10px 20px',
            cursor: 'pointer'
          }}>
        </i>
      </div>
      {/* }  */}
      {/* </div> */}


    </>
  );
}

export default App;
